import Vue from 'vue';
import Router from 'vue-router';

import app from '@/firebase';
import store from '@/store';
import LoginView from '@/pages/Login';
import NavigationView from '@/pages/Navigation';
import FinanceCreditList from '@/pages/web/FinanceCreditList';
import EntrepreneurCreditList from '@/pages/web/EntrepreneurCreditList';
import LoanhfcCreditList from '@/pages/web/LoanhfcCreditList';
import EditCreditProductView from '@/pages/web/EditCreditProductView';
import MortgageView from '@/pages/web/MortgageView';
import MortgageList from '@/pages/web/MortgageList';
import CaList from '@/pages/web/CaList';
import CAFinanceList from '@/pages/web/CAFinanceList';
import CreditProductPrint from '@/pages/web/CreditProductPrint';
import CreditProductView from '@/pages/web/CreditProductView';
import InstallmentProductView from '@/pages/web/InstallmentProductView';
import InstallmentProductPrint from '@/pages/web/InstallmentProductPrint';
import ApplyPage from '@/pages/web/ApplyPage';
import ApplyTemplatePage from '@/pages/web/ApplyTemplatePage';
import ContractTemplate from '@/pages/web/ContractTemplate';
import EditCreditProduct from '@/pages/web/EditCreditProduct';
import Contract from '@/pages/web/Contract';
import SearchFinanceInfo from '@/pages/web/SearchFinanceInfo';
import AgentView from '@/pages/web/agents';
import AgentContract from '@/pages/web/AgentContract';
import CAProductView from '@/pages/web/CAProductView';
import QuestionList from '@/pages/web/QuestionList';
import NoticeList from '@/pages/web/NoticeList';
import NoticeDetailView from '@/pages/web/NoticeDetailView';
import ReportChart from '@/pages/web/ReportChart';
import LoanhfcV202105View from '@/pages/web/LoanhfcV202105View';
import LoanhfcView from '@/pages/web/loanhfcView';
import LoanhfcEditView from '@/pages/web/loanhfcEditView';
import LoanhfcCarFinanceList from '@/pages/web/LoanhfcCarFinanceList';
import CashFlowView from '@/pages/web/CashFlowView';
import GrantNoticeView from '@/pages/web/GrantNoticeView';
import MergePdfView from '@/pages/web/MergePdfView';
import FinatradeEditView from '@/pages/web/FinatradeEditView';
import FinatradePrint from '@/pages/web/FinatradePrint';
import InstallmentPaymentView from '@/pages/web/InstallmentPaymentView';
import InstallmentReplyView from '@/pages/web/InstallmentReplyView';
import RectifierManagerView from '@/pages/web/RectifierManagerView';
import FaceRecognitionView from '@/pages/web/FaceRecognitionView';
import StockManagerView from '@/pages/web/StockManagerView';
import DeliveryNoteList from '@/pages/web/DeliveryNoteList';
import EngineSearchView from '@/pages/web/EngineSearchView';
import DeliveryNoteView from '@/components/DeliveryNoteView';
import CreditLoanList from '@/pages/web/CreditLoanList';
import MortgagePrintView from '@/pages/web/MortgagePrintView';
import ApprovedView from '@/pages/web/ApprovedView';
import RequestPaymentView from '@/pages/web/RequestPaymentView';
import InsureAgentList from '@/pages/web/InsureAgentList';
import AgentCaseCountView from '@/pages/web/AgentCaseCountView';
import GooddealList from '@/pages/web/GooddealList';
import TCBPayment from '@/pages/web/TCBPayment';
import PaymentResultView from '@/pages/web/PaymentResultView';
import MarketPaymentView from '@/pages/web/MarketPaymentView';
import CCHFinanceList from '@/pages/web/CCHFinanceList';
import AgentContractToolView from '../components/AgentContractToolView';
// eslint-disable-next-line import/first
import AppropriationEditView from '@/pages/web/AppropriationEditView';
// eslint-disable-next-line import/first
import AccountReportView from '@/pages/web/AccountReportView';
// eslint-disable-next-line import/first
import FileList from '@/pages/web/FileList';
// eslint-disable-next-line import/first
import CompanyDocList from '@/pages/web/CompanyDocList';
// eslint-disable-next-line import/first
import CompanyDocView from '@/pages/web/CompanyDocView';
// eslint-disable-next-line import/first
import CompanyReportChart from '@/pages/web/CompanyReportChart';
// eslint-disable-next-line import/first
import ChaileaseList from '@/pages/web/ChaileaseList';
// eslint-disable-next-line import/first
import TACFinanceList from '@/pages/web/TACFinanceList';
// eslint-disable-next-line import/first
import CCH21FinanceList from '@/pages/web/CCH21FinanceList';
// eslint-disable-next-line import/first
import FinanceInsureList from '@/pages/web/FinanceInsureList';
// eslint-disable-next-line import/first
import assignorList from '@/pages/web/assignorList';
// eslint-disable-next-line import/first
import FinatradeMotoPrint from '@/pages/web/FinatradeMotoPrint';
// eslint-disable-next-line import/first
import TradeCarList from '@/pages/web/TradeCarList';
// eslint-disable-next-line import/first
import ChaileaseContractView from '@/pages/web/ChaileaseContractView';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'LoginView',
      component: LoginView,
    },
    {
      path: '/home',
      name: 'NavigationView',
      component: NavigationView,
      children: [
        {
          path: 'index',
          name: 'FinanceCreditList',
          component: FinanceCreditList,
        },
        {
          path: 'agent',
          name: 'AgentView',
          component: AgentView,
        },
        {
          path: 'agentCaseCount',
          name: 'AgentCaseCountView',
          component: AgentCaseCountView,
        },
        {
          path: 'FinanceCreditList',
          name: 'FinanceCreditList',
          component: FinanceCreditList,
        },
        {
          path: 'InsureAgentList',
          name: 'InsureAgentList',
          component: InsureAgentList,
        },
        {
          path: 'EditCreditProductView',
          name: 'EditCreditProductView',
          component: EditCreditProductView,
        },
        {
          path: 'EditCreditProduct',
          name: 'EditCreditProduct',
          component: EditCreditProduct,
        },
        {
          path: 'MortgageList',
          name: 'MortgageList',
          component: MortgageList,
        },
        {
          path: 'CaList',
          name: 'CaList',
          component: CaList,
        },
        {
          path: 'GooddealList',
          name: 'GooddealList',
          component: GooddealList,
        },
        {
          path: 'CAFinanceList',
          name: 'CAFinanceList',
          component: CAFinanceList,
        },
        {
          path: 'QuestionList',
          name: 'QuestionList',
          component: QuestionList,
        },
        {
          path: 'NoticeList',
          name: 'NoticeList',
          component: NoticeList,
        },
        {
          path: 'NoticeDetailView',
          name: 'NoticeDetailView',
          component: NoticeDetailView,
        },
        {
          path: 'ReportChart',
          name: 'ReportChart',
          component: ReportChart,
        },
        {
          path: 'CashFlowView',
          name: 'CashFlowView',
          component: CashFlowView,
        },
        {
          path: 'RectifierManagerView',
          name: 'RectifierManagerView',
          component: RectifierManagerView,
        },
        {
          path: 'EngineSearchView',
          name: 'EngineSearchView',
          component: EngineSearchView,
        },
        {
          path: 'StockManagerView',
          name: 'StockManagerView',
          component: StockManagerView,
        },
        {
          path: 'DeliveryNoteList',
          name: 'DeliveryNoteList',
          component: DeliveryNoteList,
        },
        {
          path: 'GrantNoticeView',
          name: 'GrantNoticeView',
          component: GrantNoticeView,
        },
        {
          path: 'MergePdfView',
          name: 'MergePdfView',
          component: MergePdfView,
        },
        {
          path: 'InstallmentPaymentView',
          name: 'InstallmentPaymentView',
          component: InstallmentPaymentView,
        },
        {
          path: 'InstallmentReplyView',
          name: 'InstallmentReplyView',
          component: InstallmentReplyView,
        },
        {
          path: 'EntrepreneurCreditList',
          name: 'EntrepreneurCreditList',
          component: EntrepreneurCreditList,
        },
        {
          path: 'LoanhfcCreditList',
          name: 'LoanhfcCreditList',
          component: LoanhfcCreditList,
        },
        {
          path: 'CreditLoanList',
          name: 'CreditLoanList',
          component: CreditLoanList,
        },
        {
          path: 'RequestPaymentView',
          name: 'RequestPaymentView',
          component: RequestPaymentView,
        },
        {
          path: 'CCH21FinanceList',
          name: 'CCH21FinanceList',
          component: CCH21FinanceList,
        },
        {
          path: 'ContractToolView',
          name: 'AgentContractToolView',
          component: AgentContractToolView,
        },
        {
          path: 'TCBPayment',
          name: 'TCBPayment',
          component: TCBPayment,
          beforeEnter: (to, from, next) => {
            next({ query: to.query });
          },
        },
        {
          path: 'CCHFinanceList',
          name: 'CCHFinanceList',
          component: CCHFinanceList,
          beforeEnter: (to, from, next) => {
            next({ query: to.query });
          },
        },
        {
          path: 'FileList',
          name: 'FileList',
          component: FileList,
          beforeEnter: (to, from, next) => {
            next({ query: to.query });
          },
        },
        {
          path: 'CompanyDocList',
          name: 'CompanyDocList',
          component: CompanyDocList,
          beforeEnter: (to, from, next) => {
            next({ query: to.query });
          },
        },
        {
          path: 'CompanyReportChart',
          name: 'CompanyReportChart',
          component: CompanyReportChart,
          beforeEnter: (to, from, next) => {
            next({ query: to.query });
          },
        },
        {
          path: 'AppropriationEditView',
          name: 'AppropriationEditView',
          component: AppropriationEditView,
          beforeEnter: (to, from, next) => {
            next({ query: to.query });
          },
        },
        {
          path: 'AccountReportView',
          name: 'AccountReportView',
          component: AccountReportView,
          beforeEnter: (to, from, next) => {
            next({ query: to.query });
          },
        },
        {
          path: 'LoanhfcCarFinanceList',
          name: 'LoanhfcCarFinanceList',
          component: LoanhfcCarFinanceList,
          beforeEnter: (to, from, next) => {
            next({ query: to.query });
          },
        },
        {
          path: 'ChaileaseList',
          name: 'ChaileaseList',
          component: ChaileaseList,
          beforeEnter: (to, from, next) => {
            next({ query: to.query });
          },
        },
        {
          path: 'TACFinanceList',
          name: 'TACFinanceList',
          component: TACFinanceList,
          beforeEnter: (to, from, next) => {
            next({ query: to.query });
          },
        },
        {
          path: 'FinanceInsureList',
          name: 'FinanceInsureList',
          component: FinanceInsureList,
          beforeEnter: (to, from, next) => {
            next({ query: to.query });
          },
        },
        {
          path: 'assignorList',
          name: 'assignorList',
          component: assignorList,
          beforeEnter: (to, from, next) => {
            next({ query: to.query });
          },
        },
        {
          path: 'TradeCarList',
          name: 'TradeCarList',
          component: TradeCarList,
          beforeEnter: (to, from, next) => {
            next({ query: to.query });
          },
        },
      ],
    },
    {
      path: '/TCBPayment',
      name: 'TCBPayment',
      component: TCBPayment,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/CompanyDocView',
      name: 'CompanyDocView',
      component: CompanyDocView,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/paymentInfo',
      name: 'PaymentResultView',
      component: PaymentResultView,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/MarketPaymentView',
      name: 'MarketPaymentView',
      component: MarketPaymentView,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/faceRecognitionView',
      name: 'faceRecognitionView',
      component: FaceRecognitionView,
    },
    {
      path: '/loanhfcView',
      name: 'loanhfcView',
      component: LoanhfcView,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/loanhfcV202105View',
      name: 'loanhfcV202105View',
      component: LoanhfcV202105View,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/loanhfcEditView',
      name: 'loanhfcEditView',
      component: LoanhfcEditView,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/FinatradeEditView',
      name: 'FinatradeEditView',
      component: FinatradeEditView,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/FinatradePrint',
      name: 'FinatradePrint',
      component: FinatradePrint,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/FinatradeMotoPrint',
      name: 'FinatradeMotoPrint',
      component: FinatradeMotoPrint,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/AgentContract',
      name: 'AgentContract',
      component: AgentContract,
    },
    {
      path: '/EditCreditProduct',
      name: 'EditCreditProduct',
      component: EditCreditProduct,
    },
    {
      path: '/MortgageView',
      name: 'MortgageView',
      component: MortgageView,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/MortgagePrintView',
      name: 'MortgagePrintView',
      component: MortgagePrintView,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/ApprovedView',
      name: 'ApprovedView',
      component: ApprovedView,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/CreditProductPrint',
      name: 'CreditProductPrint',
      component: CreditProductPrint,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/CreditProductView',
      name: 'CreditProductView',
      component: CreditProductView,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/ChaileaseContractView',
      name: 'ChaileaseContractView',
      component: ChaileaseContractView,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/InstallmentProductView',
      name: 'InstallmentProductView',
      component: InstallmentProductView,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/InstallmentProductPrint',
      name: 'InstallmentProductPrint',
      component: InstallmentProductPrint,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/CAProductView',
      name: 'CAProductView',
      component: CAProductView,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/ApplyPage',
      name: 'ApplyPage',
      component: ApplyPage,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/ApplyTemplatePage',
      name: 'ApplyTemplatePage',
      component: ApplyTemplatePage,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/ContractTemplate',
      name: 'ContractTemplate',
      component: ContractTemplate,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/Contract',
      name: 'Contract',
      component: Contract,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/EditCreditProduct',
      name: 'EditCreditProduct',
      component: EditCreditProduct,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/SearchFinanceInfo',
      name: 'SearchFinanceInfo',
      component: SearchFinanceInfo,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/ReportChart',
      name: 'ReportChart',
      component: ReportChart,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
    {
      path: '/DeliveryNoteView',
      name: 'DeliveryNoteView',
      component: DeliveryNoteView,
      beforeEnter: (to, from, next) => {
        next({ query: to.query });
      },
    },
  ],
});

document.title = '數位線上資融進件平台';
const metaKeywords = document.createElement('meta');
metaKeywords.name = 'keywords';
metaKeywords.content = '數位線上資融進件平台';
document.head.appendChild(metaKeywords);

const description = document.createElement('meta');
description.name = 'description';
description.content = '數位線上資融進件平台';
document.head.appendChild(description);

router.beforeEach((to, from, next) => {
  const auth = app().auth();
  auth.onAuthStateChanged((firebaseUser) => {
    const isLogin = firebaseUser;
    console.log(`no login ${from.path} , to Path ${to.path}`);
    if (isLogin) {
      store.dispatch('fetchUserInfo', firebaseUser.uid).then(() => {
        if (to.path === '/') {
          next({ path: 'home/index' });
        }
        if (to.path === '/home/index') {
          next();
        }
        next();
      });
    } else if (to.path !== '/login' && to.path === '/') {
      next({ path: '/login' });
    } else if (to.path === '/login') {
      next();
    } else if (to.path.indexOf('EditCreditProduct') > -1) {
      console.log(`query === ${JSON.stringify(to.query)}`);
      if (to.query.editIndex === '-1') {
        next();
      } else {
        next({ path: '/login' });
      }
    } else if (to.path.indexOf('EngineSearchView') > -1 || to.path.indexOf('AgentContract') > -1 || to.path.indexOf('MarketPaymentView') > -1) {
      next();
    } else if (to.path.indexOf('NoticeList') > -1) {
      next();
    } else if (to.path.indexOf('NoticeDetailView') > -1) {
      next();
    } else {
      next({ path: '/login' });
    }
  });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js